import { render, staticRenderFns } from "./PopupInfoWithProperties.vue?vue&type=template&id=3f334e74&scoped=true&"
import script from "./PopupInfoWithProperties.vue?vue&type=script&lang=js&"
export * from "./PopupInfoWithProperties.vue?vue&type=script&lang=js&"
import style0 from "./PopupInfoWithProperties.vue?vue&type=style&index=0&id=3f334e74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f334e74",
  null
  
)

export default component.exports